import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export * from "@/ui/lib/utils/breakpoints/breakpoint.utils";
export * from "@/ui/lib/utils/stories/story.utils";

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
